import { X } from "lucide-react"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface PdfThumbnailProps {
  src: string
  label: string
  onRemove?: () => void
  className?: string
}

export function PdfThumbnail({
  src,
  label,
  onRemove,
  className,
}: PdfThumbnailProps) {
  return (
    <div
      className={cn("group bg-card relative rounded-lg border p-2", className)}
    >
      <img
        src={src}
        alt={label}
        className="h-32 w-auto rounded object-contain"
      />
      <p className="text-muted-foreground mt-1 truncate text-xs">{label}</p>
      {onRemove && (
        <Button
          variant="secondary"
          size="icon"
          className="absolute -top-2 -right-2 h-6 w-6 rounded-full opacity-0 transition-opacity group-hover:opacity-100"
          onClick={onRemove}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  )
}
